import { Card, Modal } from "react-bootstrap";
import "../style.scss";

const VideoModal = ({ modal, setModal, video }) => {
	return (
		<Modal
			className="fade design-modal"
			show={modal}
			onHide={() => {
				setModal();
			}}>
			{/* <Card>
				<Card.Body> */}
			<video className="w-100 " height={450} controls autoPlay>
				<source src={video} type="video/mp4" />
				<source src={video} type="video/ogg" />
				Your browser does not support the video tag.
			</video>
			{/* </Card.Body>
			</Card> */}
		</Modal>
	);
};

export default VideoModal;
